export { localeMap } from './localeMap';
export { i18instance } from './i18n';
